export default class GetCursosNoProgramadosByPersonal {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal) {
    try {
      const result = await this.#repository.getCursosNoProgramadosByPersonal(idPersonal)
      return result
    } catch (error) {
      throw error
    }
  }
}
